import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import GUI from "lil-gui";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

/**
 * Base
 */
// Debug
/* const gui = new GUI(); */

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Une variable global qui va me servir à être TWik dans le GUI si besoin
const global = {};

// Ce loader pour les textures JPG classiques
const textureLoader = new THREE.TextureLoader();

// Scene
const scene = new THREE.Scene();
/* // Assignation de l'image au fond de la scène
scene.background = backgroundImage; */

/**
 * Update all material function, AVANT l'environment map. Elle va servir à modifier l'intensité par exemple de l'nevironnement map sur chaque objet de la scene individuellement (avec la lethode traverse())
 */

const updateAllMaterials = () => {
  // La fonction callback sera appelée sur chaque child de la scene
  // Du coup on va rajouter une condition pour qu'elle ne soit appliqué que sur les meshes qui acceptent les environement map, cad qui ont un MeshStandardMaterial avec les methodes isMesh() et isMeshStandardMaterial() fournies par ThreeJS
  scene.traverse((child) => {
    if (child.isMesh && child.material.isMeshStandardMaterial) {
      //console.log(child);
      //On modifie ensuite l'intensité de l'environment map
      child.material.envMapIntensity = global.envMapIntensity;
    }
  });
};

/**
 * Environment map
 */

// Avec cette propriété je peux régler le flou du background de la scene
scene.backgroundBlurriness = 0;
/* gui.add(scene, "backgroundBlurriness").min(0).max(1).step(0.001); */

// Avec celle ci, l'intensity de l'image de fond
scene.backgroundIntensity = 1.5;
/* gui.add(scene, "backgroundIntensity").min(0).max(10).step(0.001); */

//global intensity (je lets dans la variable globale créée en haut l'intensity de l'environment map pour pouvoir la Twik dans le GUI)
global.envMapIntensity = 1;
/* gui
  .add(global, "envMapIntensity")
  .min(0)
  .max(10)
  .step(0.001)
  .onChange(updateAllMaterials);
 */
//--------------------------------------------------------------------------------
// Ici on va charger la texture LDR equirectangular
const environmentMap = textureLoader.load(
  "/background/blockadesLabsSkybox/candyWorld-psd.jpg"
);
environmentMap.mapping = THREE.EquirectangularReflectionMapping;
scene.background = environmentMap;

// Attention : par defaut ThreeJS considère le space Color comme Linear et les images d'environnement comme celle ci sont en SRGB
// Je peux donc le changer ici :
environmentMap.colorSpace = THREE.SRGBColorSpace;

/**
 * Models
 */

// Déclarez une variable globale pour stocker l'objet chargé
let myObject;

const gltfLoader = new GLTFLoader();

// Dans votre chargement GLTFLoader, affectez l'objet chargé à cette variable
gltfLoader.load(
  "/models/Donut/glTF/donut.gltf",
  (gltf) => {
    console.log("success");
    console.log(gltf);

    gltf.scene.scale.set(3.5, 3.5, 3.5);
    myObject = gltf.scene;
    scene.add(gltf.scene);
    // J'appele la fonction updateAllMaterials()
    updateAllMaterials();
  },
  (progress) => {
    console.log("progress");
    console.log(progress);
  },
  (error) => {
    console.log("error");
    console.log(error);
  }
);

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 2.4);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 1.8);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.set(1024, 1024);
directionalLight.shadow.camera.far = 15;
directionalLight.shadow.camera.left = -7;
directionalLight.shadow.camera.top = 7;
directionalLight.shadow.camera.right = 7;
directionalLight.shadow.camera.bottom = -7;
directionalLight.position.set(5, 5, 5);
scene.add(directionalLight);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(2, 2, 2);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.target.set(0, 0, 0);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  // Update controls
  controls.update();

  /*   // Rotate camera around the loaded object
  if (myObject) {
    const radius = 5; // Rayon de l'orbite autour de l'objet
    const angle = elapsedTime * Math.PI * 0.1; // Vitesse de rotation
    camera.position.x = myObject.position.x + radius * Math.cos(angle);
    camera.position.z = myObject.position.z + radius * Math.sin(angle);
    camera.lookAt(myObject.position); // Faites regarder la caméra vers l'objet
  } */

  // Rotating Donuts
  if (myObject) {
    myObject.rotation.y = elapsedTime / 2;
  }

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
